import { Button, Container, FormControl, InputLabel, ListSubheader, MenuItem, Select, Stack } from "@mui/material"
import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { TerrorZone, TerrorZoneLabels, TerrorZoneListAct1, TerrorZoneListAct2, TerrorZoneListAct3, TerrorZoneListAct4, TerrorZoneListAct5 } from "@tt/common"

import './tracker.css'
import { vouchCurrentZone } from "./trackerSlice";
import { useParams } from "react-router-dom";

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
const DEFAULT_LADDER = 'ladder';

export const VouchForm = (props: {closeForm: Function}) => {
  const { ladder } = useParams();
  const [terrorZone, setTerrorZone] = useState<TerrorZone | string>('');
  const [disableVouchButton, setDisableVouchButton] = useState(true);
  const [vouchButtonColour, setVouchButtonColour] = useState<'vouch-error' | undefined>()
  const [vouchLabel, setVouchLabel] = useState('Vouch!');
  const { currentZone } = useAppSelector(state => state.tracker);
  const { userData } = useAppSelector(state => state.login);
  const dispatch = useAppDispatch();

  const onTerrorZoneChange = (selected: TerrorZone | string) => {
    setTerrorZone(selected);
    if (selected) {
      setDisableVouchButton(false);
    }
  }
  const onVouch = async () => {
    setDisableVouchButton(true);
    setVouchLabel('Submitting...');
    const request: any = {
      ladder: ladder || DEFAULT_LADDER, 
      zone: terrorZone! as TerrorZone
    };
    if (userData) {
      request.voucher = userData.userId;
    }
    console.log(request);
    const response = await dispatch(vouchCurrentZone(request));
    console.log('Got vouch response')
    if (response.meta.requestStatus === 'rejected') {
      setVouchLabel('Already vouched this hour');
      setDisableVouchButton(true);
      setVouchButtonColour('vouch-error');
    } else if (response.meta.requestStatus === 'fulfilled') {
      setVouchLabel('Submitted!');
      await delay(2000);
      props.closeForm();
    }
  }

  const candidateList = currentZone.candidates.map(candidate => candidate.name);
  const candidateSet = new Set(candidateList);

  const tz1Filtered = TerrorZoneListAct1.filter(tz => !candidateSet.has(tz));
  const tz2Filtered = TerrorZoneListAct2.filter(tz => !candidateSet.has(tz));
  const tz3Filtered = TerrorZoneListAct3.filter(tz => !candidateSet.has(tz));
  const tz4Filtered = TerrorZoneListAct4.filter(tz => !candidateSet.has(tz));
  const tz5Filtered = TerrorZoneListAct5.filter(tz => !candidateSet.has(tz));

  return <Container className='vouch-form-container'>
    <Stack spacing={1}>
      <FormControl fullWidth>
        <InputLabel id='terror-zone'>Terror Zone</InputLabel>
        <Select
            labelId='terror-zone'
            id='terror-zone'
            value={terrorZone}
            label='Terror Zone'
            onChange={(e) => onTerrorZoneChange(e.target.value as TerrorZone)}>

          {candidateList.length ? <ListSubheader>Current</ListSubheader> : undefined}
          {candidateList.map(candidate => (
            <MenuItem key={candidate} value={candidate}>{TerrorZoneLabels[candidate]}</MenuItem>
          ))}

          {tz1Filtered.length ? <ListSubheader>Act I</ListSubheader> : undefined}
          {tz1Filtered.map(tz => (
            <MenuItem key={tz} value={tz}>{TerrorZoneLabels[tz]}</MenuItem>
          ))}

          {tz2Filtered.length ? <ListSubheader>Act II</ListSubheader> : undefined}
          {tz2Filtered.map(tz => (
            <MenuItem key={tz} value={tz}>{TerrorZoneLabels[tz]}</MenuItem>
          ))}

          {tz3Filtered.length ? <ListSubheader>Act III</ListSubheader> : undefined}
          {tz3Filtered.map(tz => (
            <MenuItem key={tz} value={tz}>{TerrorZoneLabels[tz]}</MenuItem>
          ))}

          {tz4Filtered.length ? <ListSubheader>Act IV</ListSubheader> : undefined}
          {tz4Filtered.map(tz => (
            <MenuItem key={tz} value={tz}>{TerrorZoneLabels[tz]}</MenuItem>
          ))}

          {tz5Filtered.length ? <ListSubheader>Act V</ListSubheader> : undefined}
          {tz5Filtered.map(tz => (
            <MenuItem key={tz} value={tz}>{TerrorZoneLabels[tz]}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <Button disabled={disableVouchButton} className={vouchButtonColour} variant='outlined' onClick={onVouch}>
          {vouchLabel}
        </Button>
      </FormControl>
    </Stack>
  </Container>
}